import { render, staticRenderFns } from "./PromoPackPopup.vue?vue&type=template&id=09a77a58&scoped=true"
import script from "./PromoPackPopup.vue?vue&type=script&lang=js"
export * from "./PromoPackPopup.vue?vue&type=script&lang=js"
import style0 from "./PromoPackPopup.vue?vue&type=style&index=0&id=09a77a58&lang=scss&scoped=true"
import style1 from "./PromoPackPopup.vue?vue&type=style&index=1&id=09a77a58&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a77a58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a77a58')) {
      api.createRecord('09a77a58', component.options)
    } else {
      api.reload('09a77a58', component.options)
    }
    module.hot.accept("./PromoPackPopup.vue?vue&type=template&id=09a77a58&scoped=true", function () {
      api.rerender('09a77a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/PromoPackPopup.vue"
export default component.exports